module.exports = __webpack_public_path__ + "img/sample_img_phone_02.911b2341.png";